import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerify from './pages/EmailVerify';
import PostDetail from './pages/PostDetail';
import CreatePost from './pages/CreatePost';
import EditPost from './pages/EditPost';
import UserCenter from './pages/UserCenter';
import UserProfile from './pages/UserProfile';
import Storage from './pages/Storage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminCategories from './pages/admin/AdminCategories';
import AdminPosts from './pages/admin/AdminPosts';
import AdminSensitiveWords from './pages/admin/AdminSensitiveWords';
import AdminSiteConfig from './pages/admin/AdminSiteConfig';
import AdminChat from './pages/admin/AdminChat';
import AdminOperationLogs from './pages/admin/AdminOperationLogs';
import AdminExpansionOrders from './pages/admin/AdminExpansionOrders';
import AdminDonationOrders from './pages/admin/AdminDonationOrders';
import AdminPendingOrders from './pages/admin/AdminPendingOrders';
import AdminExperience from './pages/admin/AdminExperience';
import AdminMaster from './pages/admin/AdminMaster';
import RoomManagementPage from './pages/admin/RoomManagementPage';
import SearchResults from './pages/SearchResults';
import CategoryView from './pages/CategoryView';
import ChatRoom from './pages/ChatRoom';
import RoomListPage from './pages/RoomListPage';
import RoomChatPage from './pages/RoomChatPage';
import BusinessCooperation from './pages/BusinessCooperation';
import Donation from './pages/Donation';
import JoinUs from './pages/JoinUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';
import MessagesPage from './pages/MessagesPage';
import TermsOfService from './pages/TermsOfService';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="email-verify" element={<EmailVerify />} />
        <Route path="post/:id" element={<PostDetail />} />
        <Route path="create-post" element={<CreatePost />} />
        <Route path="edit-post/:id" element={<EditPost />} />
        <Route path="user-center" element={<UserCenter />} />
        <Route path="user/:id" element={<UserProfile />} />
        <Route path="storage" element={<Storage />} />
        <Route path="search" element={<SearchResults />} />
        <Route path="category/:id" element={<CategoryView />} />
        <Route path="chat" element={<ChatRoom />} />
        <Route path="rooms" element={<RoomListPage />} />
        <Route path="rooms/:roomId" element={<RoomChatPage />} />
        <Route path="room-management" element={<RoomManagementPage />} />
        <Route path="business-cooperation" element={<BusinessCooperation />} />
        <Route path="join-us" element={<JoinUs />} />
        <Route path="donation" element={<Donation />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="messages" element={<MessagesPage />} />
      </Route>

      {/* 管理后台 - 独立布局 */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="posts" element={<AdminPosts />} />
        <Route path="sensitive-words" element={<AdminSensitiveWords />} />
        <Route path="chat" element={<AdminChat />} />
        <Route path="expansion-orders" element={<AdminExpansionOrders />} />
        <Route path="donation-orders" element={<AdminDonationOrders />} />
        <Route path="pending-orders" element={<AdminPendingOrders />} />
        <Route path="experience" element={<AdminExperience />} />
        <Route path="site-config" element={<AdminSiteConfig />} />
        <Route path="operation-logs" element={<AdminOperationLogs />} />
      </Route>

      {/* 站长后台 - 独立系统 */}
      <Route path="/admin-master" element={<AdminMaster />} />
    </Routes>
  );
};

export default App;
